import React from 'react'

import { useField } from 'formik'

import DefaultFieldProps from './DefaultFieldProps'
import Error from './FormItemError'
import Label from './Label'
import RedAsterisk from './RedAsteriks'

import styles from './index.module.css'

type Props = DefaultFieldProps & {
  children?: any
  inlineLabel?: boolean
  rightLabel?: boolean
}
const FormGroup: React.FC<Props> = (props) => {
  const [, meta] = useField(props.name)

  return (
    <div className={styles.formGroup}>
      {props.rightLabel && props.children}
      {props.label && (
        <Label
          htmlFor={props.name}
          className={`${props.inlineLabel ? styles.inlineLabel : styles.label} ${
            props.rightLabel ? styles.rightLabel : ''
          }`}
        >
          {props.showRequiredSign && <RedAsterisk className={'mr-4'} />}
          {props.label}
          {props.optional && <span className={styles.fieldOptional}> (optional)</span>}
        </Label>
      )}

      {!props.rightLabel && props.children}

      {meta.error && meta.touched && <Error noErrorHeight={props.noErrorHeight} children={meta.error} />}
      {props.helperText && <span className={styles.helpText}>{props.helperText}</span>}
    </div>
  )
}
export default FormGroup
